module.exports = __webpack_public_path__ + "img/3.1d4b9c70.jpg";